/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { VendorWorkspaceApproveLogDto } from '../../models/vendor-workspace-approve-log-dto';

export interface VendorWorkspaceApproveLogControllerFindById$Params {
  id: string;
}

export function vendorWorkspaceApproveLogControllerFindById(http: HttpClient, rootUrl: string, params: VendorWorkspaceApproveLogControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<VendorWorkspaceApproveLogDto>> {
  const rb = new RequestBuilder(rootUrl, vendorWorkspaceApproveLogControllerFindById.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<VendorWorkspaceApproveLogDto>;
    })
  );
}

vendorWorkspaceApproveLogControllerFindById.PATH = '/api/vendorWorkspaceApproveLog/{id}';
